import { useCallback, useEffect, useState } from 'react'
import { containsField } from '@user/components/Settings/PendingLeadSettings/helpers'
import type { IAutoReviewAdditionalField } from '@user/store/autoReviewSettings'

type Props = {
  open: boolean
  added: IAutoReviewAdditionalField[]
}

export const useData = ({ open, added }: Props) => {
  const [picks, setPicks] = useState<IAutoReviewAdditionalField[]>([])

  useEffect(() => {
    if (open) setPicks([])
  }, [open])

  const isPicked = useCallback(
    (field: IAutoReviewAdditionalField) => containsField(picks, field),
    [picks],
  )

  const isAdded = useCallback(
    (field: IAutoReviewAdditionalField) => containsField(added, field),
    [added],
  )

  return {
    picks,
    setPicks,
    isPicked,
    isAdded,
    submitDisabled: picks.length === 0,
  }
}

export type UseData = ReturnType<typeof useData>
